var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (layout, partner, showBanner, undefined) {
buf.push("<div id=\"partner2-overview\"><div class=\"partner2-overview-container\">");
if ( showBanner)
{
buf.push("<section class=\"partner2-overview-section partner2-overview-messages\"><p class=\"message-title\">" + (jade.escape((jade_interp = partner.get('name')) == null ? '' : jade_interp)) + " participates in Artsy’s art fair coverage</p><p class=\"message-title\">but does not have a full profile.</p><p class=\"message-content\">A full Artsy profile includes artists, works, shows, and contact information for collectors.</p><br><br><p class=\"message-content\">Do you represent " + (jade.escape((jade_interp = partner.get('name')) == null ? '' : jade_interp)) + "?\nLearn about" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "<a href=\"https://partners.artsy.net\" class=\"faux-underline\">Artsy gallery partnerships.</a></p></section>");
}
// iterate layout
;(function(){
  var $$obj = layout;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var module = $$obj[$index];

if ( module.component || module.template)
{
buf.push("<section" + (jade.attr("data-module", module.name, true, true)) + (jade.attr("data-component", (module.component ? module.component.name : null), true, true)) + " class=\"partner2-overview-section\">");
if ( module.title)
{
buf.push("<h3 class=\"partner2-overview-section-title\">" + (jade.escape(null == (jade_interp = module.title) ? "" : jade_interp)) + "</h3>");
}
if ( module.viewAll)
{
buf.push("<div class=\"partner2-overview-section-view-all\"><a" + (jade.attr("href", module.viewAll, true, true)) + ">View All</a></div>");
}
buf.push("<div class=\"partner2-overview-section-content\">");
if ( module.template)
{
buf.push(null == (jade_interp = module.template) ? "" : jade_interp);
}
else
{
buf.push("<div class=\"loading-spinner\"></div>");
}
buf.push("</div></section>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var module = $$obj[$index];

if ( module.component || module.template)
{
buf.push("<section" + (jade.attr("data-module", module.name, true, true)) + (jade.attr("data-component", (module.component ? module.component.name : null), true, true)) + " class=\"partner2-overview-section\">");
if ( module.title)
{
buf.push("<h3 class=\"partner2-overview-section-title\">" + (jade.escape(null == (jade_interp = module.title) ? "" : jade_interp)) + "</h3>");
}
if ( module.viewAll)
{
buf.push("<div class=\"partner2-overview-section-view-all\"><a" + (jade.attr("href", module.viewAll, true, true)) + ">View All</a></div>");
}
buf.push("<div class=\"partner2-overview-section-content\">");
if ( module.template)
{
buf.push(null == (jade_interp = module.template) ? "" : jade_interp);
}
else
{
buf.push("<div class=\"loading-spinner\"></div>");
}
buf.push("</div></section>");
}
    }

  }
}).call(this);

buf.push("</div></div>");}.call(this,"layout" in locals_for_with?locals_for_with.layout:typeof layout!=="undefined"?layout:undefined,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined,"showBanner" in locals_for_with?locals_for_with.showBanner:typeof showBanner!=="undefined"?showBanner:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;